import cls from './Sharing.module.scss';
import tgIcon from '../../assets/images/tg.svg';
import vkIcon from '../../assets/images/vk.svg';
import odkIcon from '../../assets/images/odk.svg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { Pages } from '../../redux/pages/types';
import buttonMp3 from '../../assets/sound/button_2.mp3';
import { nextLevel, setPlay, updateChildren } from '../../redux/child/slice';
import { againGame, setIsNextlocation } from '../../redux/game/slice';
import { setEndGame, setPage } from '../../redux/pages/slice';
import { doubleHooks, setCanDoubleHooks } from '../../redux/hooks/slice';
import { useMemo } from 'react';
import { childNames } from '../../redux/child/types';

const soundButton = new Howl({
  src: [buttonMp3],
});

const Sharing = () => {
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => state.pages.currentPage);
  const count = useSelector((state: RootState) => state.game.count);
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  const children = useSelector((state: RootState) => state.children.children);
  const ramdomSpeach = useSelector((state: RootState) => state.hooks.randomSpeach);
  const shareData = {
    title: 'Заголовок финала',
    text: 'Текст финала',
    url: 'url игры',
    image: 'картинка игры',
  };

  const headerArr = [
    'Кажется, тебе самому нужен наставник… Может, это твой друг? Поделись игрой с ним.',
    'Ты хорош, нo…  не настолько, чтобы все добрались до вершины.',
    'Кто супер-мега-крутой наставник? Ты! Тебе под силу любое дело!',
  ];

  const arrDiedLenght = useMemo(() => {
    return children.filter((el) => el.isDied).length;
  }, [children]);

  const getText = () => {
    if (arrDiedLenght === 6) {
      return headerArr[0];
    } else if (arrDiedLenght === 0 && count === 5) {
      return headerArr[2];
    } else {
      return headerArr[1];
    }
  };

  const getImg = () => {
    if (arrDiedLenght === 6) {
      return 'https://memesis.ru/mentor/assets/og_1.png';
    } else if (arrDiedLenght === 0 && count === 5) {
      return 'https://memesis.ru/mentor/assets/og_3.png';
    } else {
      return 'https://memesis.ru/mentor/assets/og_2.png';
    }
  };

  const styleContainer = (page: Pages) => {
    if (page === Pages.FINAL) {
      return { top: 'calc(100vh - 150px)' };
    } else {
      return {};
    }
  };

  const getUrl = () => {
    return 'https://memesis.ru/mentor/';
  };

  const thatSound = () => {
    if (isSound) {
      soundButton.play();
    }
    if (arrDiedLenght === 6) {
      dispatch(setIsNextlocation(false));
    }
    if (ramdomSpeach === 2 || ramdomSpeach === 3) {
      dispatch(doubleHooks());
      dispatch(setCanDoubleHooks(true));
    }
    if (page === Pages.GAME) {
      dispatch(updateChildren());
      dispatch(setPlay(childNames.BLUE));
      dispatch(setPlay(childNames.ORANGE));
      dispatch(setPlay(childNames.PURPLE));
      dispatch(setPlay(childNames.PINK));
      dispatch(setPlay(childNames.GREY));
      dispatch(setPlay(childNames.YELLOW));
    }
  };

  return (
    <div className={cls.Share} style={styleContainer(page)}>
      <a
        target="_blank"
        href={`https://telegram.me/share/url?url=${getUrl()}&text=${getText()}`}
        onClick={thatSound}>
        <img alt="VK share" src={tgIcon} />
      </a>
      <a
        target="_blank"
        href={`https://vk.com/share.php?url=${getUrl()}&title=${getText()}&image=${getImg()}`}
        onClick={thatSound}>
        <img alt="Tg share" src={vkIcon} />
      </a>
      <a
        target="_blank"
        href={`https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.description=${getText()}&st.imageUrl=${getImg()}&st.shareUrl=${getUrl()}`}
        onClick={thatSound}>
        <img alt="Odk share" src={odkIcon} />
      </a>
    </div>
  );
};

export default Sharing;
